import { Grid, Stack } from '@mui/material';
import exportFromJSON from 'export-from-json';
import { Fragment } from 'react';
import DataTable from 'react-data-table-component';
import useApproverEnrollments from '../../../hooks/AuditLogReports/useApproverEnrollments';
import { AuditedUser, AuditLogReportRequest, EnrollmentGroup, FilterCriteria } from '../../../model/auditlogreports';
import ReportHeader from './ReportHeader';
import ReportToolbar from './ReportToolbar';

const ApproverEnrollments = ({ request, reportType, filterBy, users }: props) => {

    const { status, data, error, isFetching } = useApproverEnrollments(request);

    const columns = [
        {
            name: 'Approver Name',
            selector: (row: { approverName: string }) => row.approverName
        },
        {
            name: 'Approved DateTime',
            selector: (row: { approvalDate: string }) => row.approvalDate,
        },
        {
            name: 'Enrollment Status',
            selector: (row: { enrollmentStatus: string }) => row.enrollmentStatus,
        },
        {
            name: 'Reported By',
            selector: (row: { reportedBy: string | null }) => row.reportedBy || '',
        },
        {
            name: 'Enrollment Groups',
            selector: (row: { enrollmentGroups: string }) => row.enrollmentGroups,
        },
        {
            name: 'Enrolled DateTime',
            selector: (row: { enrollmentDate: string }) => row.enrollmentDate,
        },
        {
            name: 'Location / Store',
            selector: (row: { location: string }) => row.location,
        },
        {
            name: 'Reported Loss',
            selector: (row: { reportedLoss: string }) => row.reportedLoss,
        },
        {
            name: 'Case Event Type',
            selector: (row: { caseEventType: string | null }) => row.caseEventType || '',
        },
        {
            name: 'Case / Subject',
            selector: (row: { caseNumber: string | null }) => row.caseNumber || '',
        }
    ];

    const exportApproverEnrollmentsData = () => {
        const reportData = data || [];
        const fileName = 'ApproverEnrollments';
        const exportType = exportFromJSON.types.csv;
        const fields = {
            approverName: 'Approver Name', approvalDate: 'Approved DateTime', enrollmentStatus: 'Enrollment Status',
            reportedBy: 'Reported By', enrollmentGroups: 'Enrollment Groups', enrollmentDate: 'Enrolled DateTime',
            location: 'Location / Store', reportedLoss: 'Reported Loss', caseEventType: 'Case Event Type', caseNumber: 'Case / Subject'
        };

        exportFromJSON({
            data: reportData,
            fileName: fileName,
            fields: fields,
            exportType: exportType
        });
    };

    return (
        <Fragment>
            <Grid container>
                <Grid item xs={5}>
                </Grid>
                <Grid item xs={6}>
                    <ReportHeader reportType={reportType} filterBy={filterBy} users={users} />
                </Grid>
                <Grid item xs={1}>
                    <ReportToolbar export={exportApproverEnrollmentsData} />
                </Grid>
            </Grid>

            <DataTable
                columns={columns}
                data={data || []}
                fixedHeader={true}
                fixedHeaderScrollHeight={'750px'}
                pagination
            />
        </Fragment>
    );
}

type props = {
    request: AuditLogReportRequest;
    reportType: any
    filterBy: any
    users: any
}

export default ApproverEnrollments;